import MainImg from "./MainImg";
import StructBlock from "./StructBlock";
import StructText from "./StructText";

export default function Structural() {
  return (
    <>
    <MainImg />
    <StructText />
    <StructBlock />
    </>
  );
}